export default () => (
  <div>
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.9"
        d="M5.33317 6.16667V23.5C5.33317 24.0746 5.56144 24.6257 5.96777 25.0321C6.3741 25.4384 6.9252 25.6667 7.49983 25.6667H20.4998C21.0745 25.6667 21.6256 25.4384 22.0319 25.0321C22.4382 24.6257 22.6665 24.0746 22.6665 23.5V10.8705C22.6665 10.5819 22.6088 10.2961 22.4968 10.0301C22.3848 9.76407 22.2208 9.5231 22.0143 9.32134L17.2043 4.6175C16.7996 4.22171 16.256 4.00007 15.6898 4H7.49983C6.9252 4 6.3741 4.22827 5.96777 4.6346C5.56144 5.04093 5.33317 5.59203 5.33317 6.16667Z"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="9.125"
        y="7.33331"
        width="8.125"
        height="1.625"
        fill="currentColor"
      />
      <path
        d="M8.00001 12.9087C8.00001 12.4069 8.40687 12 8.90876 12H18.905C19.4068 12 19.8137 12.4069 19.8137 12.9087V21.0496C19.8137 21.5515 19.4068 21.9583 18.905 21.9583H8.90876C8.40687 21.9583 8.00001 21.5515 8.00001 21.0496V12.9087Z"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <path
        d="M14.1794 12L14.1795 21.9583"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="19.8136"
        y1="14.7962"
        x2="7.99989"
        y2="14.7962"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="19.8136"
        y1="17.3039"
        x2="7.99989"
        y2="17.3039"
        stroke="currentColor"
        stroke-width="1.2"
      />
      <line
        x1="19.8136"
        y1="19.8117"
        x2="7.99989"
        y2="19.8117"
        stroke="currentColor"
        stroke-width="1.2"
      />
    </svg>
  </div>
);
